import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

export const ResolvableServiceVersions_Versions_QueryDocument = graphql(`
  query ResolvableServiceVersions_Versions_Query($originalId: Id!) {
    findAllResolvableServiceVersionsForOneOriginalId(originalId: $originalId) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id

        code
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }

        label
        title
        content
        costUsages {
          _id
          index
          costId
          quantity {
            value
            unitId
          }
        }
        materialUsages {
          _id
          index
          materialId
          quantity {
            value
            unitId
          }
        }
        value {
          _id
          priceExcludingVat {
            _id
            value {
              __typename
              mode
              resolverId
              value
            }
            currencyId {
              __typename
              mode
              resolverId
              value
            }
          }
          discountPercentage {
            __typename
            mode
            resolverId
            value
          }
          discountAmount {
            _id
            value {
              __typename
              mode
              resolverId
              value
            }
            currencyId {
              __typename
              mode
              resolverId
              value
            }
          }
          vatId {
            __typename
            mode
            resolverId
            value
          }
        }
        statusId
        creatorId
        createdAt
        updaterId
        updatedAt
      }
    }
  }
`);

interface Props {
  readonly originalId: Id;
}

export const Versions = ({ originalId }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    ResolvableServiceVersions_Versions_QueryDocument,
    { originalId },
    { enabled: !!originalId },
  );

  if (isSuccess) {
    const versions = data.findAllResolvableServiceVersionsForOneOriginalId;

    if (versions.length) {
      return <VersionsCmp versions={versions} />;
    }

    return <NoData />;
  }

  return <Loading />;
};
